__turbopack_context__.v({
  "cardFadeIn": "value-prop-module__zAnBWW__cardFadeIn",
  "valueCard": "value-prop-module__zAnBWW__valueCard",
  "valueGrid": "value-prop-module__zAnBWW__valueGrid",
  "valueIconContainer": "value-prop-module__zAnBWW__valueIconContainer",
  "valuePropSection": "value-prop-module__zAnBWW__valuePropSection",
});
